import Vue from 'vue'
import Vuex from 'vuex'

import messages from '@/common/lang'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    msg: messages,
    noticias: [],
    normativas: null,
    cursos: null,
    juramentos: [],
    error: null,
    errorColor: 'error',
    loading: false,
    credenciales: [],
    oficinas: [],
    urlWhatsapp: '',
    menu_fixed: false,
    cantidad: {
      registros: 0,
      matriculados: 0,
      ruanna: 0,
      certificaciones: 0,
      ciudadania: 0
    },
    confirm: {
      show: false,
      text: '',
      width: 360,
      callbackOk: null,
      callbackCancel: null,
      textOk: '',
      textCancel: ''
    }
  },
  mutations: {
    setNoticias (state, payload) {
      state.noticias = payload
    },
    setNoticiasFacebock (state, payload) {
      state.noticias_facebook = payload
    },
    setNormativas (state, payload) {
      state.normativas = payload
    },
    setCursos (state, payload) {
      state.cursos = payload
    },
    setJuramentos (state, payload) {
      state.juramentos = payload
    },
    setCredenciales (state, payload) {
      state.credenciales = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setErrorColor (state, payload) {
      state.errorColor = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setOficinas (state, payload) {
      state.oficinas = payload
    },
    setMenuFixed (state, payload) {
      state.menu_fixed = payload
    },
    setCantidadMatriculacion (state, payload) {
      state.cantidad.matriculados = payload
    },
    setCantidadCiudadania (state, payload) {
      state.cantidad.ciudadania = payload
    },
    setCantidadRuanna (state, payload) {
      state.cantidad.ruanna = payload
    },
    setUrlWhatsapp (state, payload) {
      state.urlWhatsapp = payload
    },
    CLOSE_CONFIRM (state) {
      state.confirm.show = false
    }
  },
  getters: {
    juramentoConFotos: state => {
      return state.juramentos.filter(function (jura) {
        return jura.fotosJuramento.length > 0
      })
    },
    noticiasFacebook: state => {
      return state.noticias.filter(function (noticia) {
        return noticia.tipo === 3
      })
    },
    noticias: state => {
      return state.noticias.filter(function (noticia) {
        return noticia.tipo !== 3
      })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js